import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import TrainingNav from '../navigation/TrainingNav';
import TrainingSettingsRouter from './TrainingSettingsRouter';

import Overview from '../../pages/training/Overview';
import Calendar from '../../pages/training/Calendar';
import Programs from '../../pages/training/Programs';
import Workouts from '../../pages/training/Workouts';
import ExerciseLibrary from '../../pages/training/exercise-library/ExerciseLibrary';

const TrainingRouter = ({ match, location }) => {
  return (
    <TrainingNavTemplate>
      <Switch>
        <Redirect exact from='/training' to='/training/overview' />
        <Route path = {match.path + '/overview'} >
          <Overview />
        </Route>
        <Route path = {match.path + '/calendar'} >
          <Calendar />
        </Route>
        <Route path = {match.path + '/programs'} >
          <Programs />
        </Route>
        <Route path = {match.path + '/workouts'} >
          <Workouts />
        </Route>
        <Route path = {match.path + '/exercise-library'} >
          <ExerciseLibrary />
        </Route>
        <Route path = {match.path + '/settings'} >
          <TrainingSettingsRouter />
        </Route>
      </Switch>
    </TrainingNavTemplate>
  );
}

const TrainingNavTemplate = (props) => {
  return (
    <>
      <TrainingNav />
      {props.children}
    </>
  );
}

export default TrainingRouter;